import { Swiper } from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

export class NADResearch {
  private element: HTMLElement;
  private swiper: Swiper | null = null;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupSwiper();
    this.setupAnimation();
  }

  private setupSwiper(): void {
    const swiperElement = this.element.querySelector('.nad-research__swiper') as HTMLElement;
    
    if (!swiperElement) {
      console.warn('NADResearch: Swiper element not found');
      return;
    }

    // Only initialize Swiper on mobile
    // if (window.innerWidth <= 768) {
      this.swiper = new Swiper(swiperElement, {
        modules: [Navigation, Pagination, A11y],
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        grabCursor: true,
        
        // Navigation
        navigation: {
          nextEl: this.element.querySelector('.nad-research__nav-next') as HTMLElement,
          prevEl: this.element.querySelector('.nad-research__nav-prev') as HTMLElement,
        },
        
        // Pagination
        pagination: {
          el: this.element.querySelector('.nad-research__pagination') as HTMLElement,
          clickable: true,
          dynamicBullets: false,
        },
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous research card',
          nextSlideMessage: 'Next research card',
          firstSlideMessage: 'This is the first research card',
          lastSlideMessage: 'This is the last research card',
        },
        
        // Breakpoints
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
        },
        
        // Events
        on: {
          init: () => {
            console.log('NADResearch Swiper initialized');
          },
          slideChange: () => {
            // Optional: Add any slide change logic here
          },
        },
      });
    // }
  }

  private setupAnimation(): void {
    // Set up intersection observer for card animations
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.nad-research__card');
            cards.forEach((card, index) => {
              setTimeout(() => {
                card.classList.add('animate-in');
              }, index * 100); // Staggered animation
            });
            this.observer?.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    this.observer.observe(this.element);
  }

  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  public static initializeAll(): void {
    const sections = document.querySelectorAll('.nad-research');
    sections.forEach((element) => {
      if (!(element as any)._nadResearchInstance) {
        (element as any)._nadResearchInstance = new NADResearch(element as HTMLElement);
      }
    });
  }

  public static destroyAll(): void {
    const sections = document.querySelectorAll('.nad-research');
    sections.forEach((element) => {
      const instance = (element as any)._nadResearchInstance;
      if (instance) {
        instance.destroy();
        delete (element as any)._nadResearchInstance;
      }
    });
  }
}